import * as React from "react"
const IconCopy = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 20}
        height={props.height ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke ?? "#94A3B8"}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.343 13.947A1.671 1.671 0 0 1 2.5 12.5V4.167c0-.917.75-1.667 1.667-1.667H12.5c.625 0 .965.32 1.25.833M5.833 8.056a2.222 2.222 0 0 1 2.223-2.223h7.222A2.222 2.222 0 0 1 17.5 8.056v7.222a2.222 2.222 0 0 1-2.223 2.222H8.056a2.222 2.222 0 0 1-2.223-2.223V8.056Z"
        />
    </svg>
)
export default IconCopy
